import React, { useEffect, useState } from "react";
import { compose } from "recompose";
import { withTable, onMount, Page, LoadingMsg, } from "components/common";
import { withXeroErrors, withDocumentRenderer } from "components";
import { Trans, useTranslation, withTranslation } from "react-i18next";
import { HorizontalBar } from 'react-chartjs-2';
import MainCard from "./MainCard";

export const InvoicesFetch = ({
  XeroErrors,
  XeroTableDataFetch,
  data,
  item

}) => {

const { t } = useTranslation();
  
const cardColors = ['#5cb85c', '#f0ad4e', '#d9534f'];

const [isLoading, setIsLoading] = useState(true);

  function processAccountData(data) {
    const length = data.results ? data.results.length : 0;
    const account = data.results ? data.results : [];
    let lengthInvoices = 0;
    let lengthBills = 0;
    let sumAmountPaidInvoices = 0;
    let sumAmountDueInvoices = 0;
    let sumAmountPaidBills = 0;
    let sumAmountDueBills = 0;
  
    if (length > 0) {
      for (let i = 0; i < length; i++) {

        if (account[i].Type === "ACCREC") {
          lengthInvoices++;
          sumAmountDueInvoices += account[i].AmountDue;
          sumAmountPaidInvoices += account[i].Total;
        } else if (account[i].Type === "ACCPAY") {
          lengthBills++;
          sumAmountDueBills += account[i].AmountDue;
          sumAmountPaidBills += account[i].Total;
        }
      }
    } else {
      console.log("No data available");
    }
  
    return {
      lengthInvoices,
      lengthBills,
      sumAmountPaidInvoices,
      sumAmountDueInvoices,
      sumAmountPaidBills,
      sumAmountDueBills,
    };
  }

  const {
    lengthInvoices,
    lengthBills,
    sumAmountPaidInvoices,
    sumAmountDueInvoices,
    sumAmountPaidBills,
    sumAmountDueBills,
  } = processAccountData(data);
  
  function niceNumbers(number, minimumFractionDigits = 2, maximumFractionDigits = 2) {
    const formattedNumber = number.toLocaleString(undefined, {
      minimumFractionDigits,
      maximumFractionDigits,
    });
  
    const withoutFraction = formattedNumber.endsWith('.00') ? formattedNumber.split('.')[0] : formattedNumber;

    return withoutFraction.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
  
      try {
        await new Promise(resolve => setTimeout(resolve, 2000));

        if (lengthInvoices !== 0 && lengthBills !== 0) {
          setIsLoading(false);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsLoading(false);
      }
    };
  
    fetchData();
  }, [
    lengthInvoices,
    lengthBills,
  ]);

  const [loadingMessage, setLoadingMessage] = useState();
  
  useEffect(() => {
    const firstTimeoutId = setTimeout(() => {
      setLoadingMessage(t("Loading is taking longer than usual, Please make sure you have open bills/invoices or check your connection."));
    }, 15000);

    const secondTimeoutId = setTimeout(() => {
      setIsLoading(false);
    }, 30000);

    return () => {
      clearTimeout(firstTimeoutId);
      clearTimeout(secondTimeoutId);
    };
  }, []);
  

  
  const ReceivablesData = {
    labels: [t('Open Invoices'), t('Total'), t('Due')],
    datasets: [
      {
        label: t('Receivables'),
        backgroundColor: 'rgba(75,192,192,0.2)',
        borderColor: 'rgba(75,192,192,1)',
        borderWidth: 1,
        hoverBackgroundColor: 'rgba(75,192,192,0.4)',
        hoverBorderColor: 'rgba(75,192,192,1)',
        data: [lengthInvoices, parseFloat(sumAmountPaidInvoices).toFixed(2), parseFloat(sumAmountDueInvoices).toFixed(2)],
      },
    ],
  };
  
  const PayablesData = {
    labels: [t('Open Bills'), t('Total'), t('Due')],
    datasets: [
      {
        label: t('Payables'),
        backgroundColor: 'rgba(255,99,132,0.2)',
        borderColor: 'rgba(255,99,132,1)',
        borderWidth: 1,
        hoverBackgroundColor: 'rgba(255,99,132,0.4)',
        hoverBorderColor: 'rgba(255,99,132,1)',
        data: [lengthBills, parseFloat(sumAmountPaidBills).toFixed(2), parseFloat(sumAmountDueBills).toFixed(2)],
      },
    ],
  };
  
  const options = {
    scales: {
      xAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
  };
  
  const MiniCard = ({ label, value, color }) => (
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', padding: '8px', backgroundColor: color, color: '#fff', borderRadius: '4px', fontSize: '1.2em', marginBottom: '8px', textAlign: 'center' }}>
        <p style={{ marginBottom: '4px' }}>{label}:</p>
        <strong style={{fontSize: "1.3em"}}>{value}</strong>
      </div>
    );
    
    const BlockCard = ({ title, data, colors }) => (
      <div style={{ textAlign: 'center' }}>
        <div className="text-center" style={{ border: '1px solid #ddd', borderRadius: '8px', padding: '16px', marginTop: '16px', backgroundColor: '#f9f9f9', display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative' }}>
          <h3 style={{ marginBottom: '16px', fontSize: '1.5em', zIndex: 1 }}>{title}</h3>
          <div style={{ display: 'flex', gap: '16px', justifyContent: 'space-around', width: '100%' }}>
            {data.labels.map((label, index) => (
              <MiniCard key={label} label={label} value={niceNumbers(data.datasets[0].data[index])} color={colors[index]} />
            ))}
          </div>
        </div>
      </div>
    );
  
  return (
    <Page>
      <div>
        <XeroErrors color="warning" />
            <XeroTableDataFetch />
            <div className="text-center">
            <h3><Trans>Financial Overview</Trans></h3> 
            <h4>{item.ReportTitles[2]}</h4>
            </div>
            {isLoading ? (
                <div style={{ paddingTop: "2em"}} className="text-center justify-content-center">
                    <LoadingMsg/> 
                    <p>{loadingMessage}</p>
                </div>
                ) : (
                <>
                  <MainCard linkTo="/reports/payables_receivables">
                  {lengthBills !== 0 || lengthInvoices !== 0 ? (
                    <>
                      <div style={{ paddingTop: "1.5em", display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ width: '45%', textAlign: 'center' }}>
                          <h3><Trans>Receivables</Trans></h3>
                          <HorizontalBar data={ReceivablesData} options={options} />
                        </div>
                        <div style={{ width: '45%', textAlign: 'center' }}>
                          <h3><Trans>Payables</Trans></h3>
                          <HorizontalBar data={PayablesData} options={options} />
                        </div>
                      </div>
                    </>
                    ) : (
                      <div 
                      className="text-muted text-center"
                      style={{fontSize: "1.5em", }}>
                      <p><Trans>You currently have no outstanding bills or invoices.</Trans></p>
                      <p><Trans>There is no content available to display at this time.</Trans></p>
                      </div>
                  )}
                  </MainCard>
                
                    <div style={{ paddingTop: "30px" }}>
                        <BlockCard title={t("Receivables")} data={ReceivablesData} colors={cardColors} />
                        <BlockCard title={t("Payables")} data={PayablesData} colors={cardColors} />
                    </div>
                </>
            )}
      </div>
    </Page>
  );
};

export const enhance = compose(
  withTranslation(),
  withXeroErrors(),
  withTable({
    limit: 100,
    url: "invoices",
    filters:{
      raw: 'Status="AUTHORISED"',
      Status: "AUTHORISED"
    },
  }),
  onMount(({ match, xero }) => async () => {
    const { id } = match.params;
    const item = await xero
      .get(`reports/BudgetSummary`)
      .get("data")
      .then((item) => ({
        ...item,
      }));
    return {
      item,
    };
  }),
);

export default enhance(InvoicesFetch);
